'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formToJSON;
function extractObject(object) {
  return Object.keys(object).reduce(function (newObject, key) {
    if (object[key] && object[key] === Object(object[key])) {
      if (Array.isArray(object[key])) {
        newObject[key] = extractArray(object[key]);
      } else if ('value' in object[key]) {
        newObject[key] = object[key].value;
      } else {
        newObject[key] = extractObject(object[key]);
      }
    }

    return newObject;
  }, {});
}

function extractArray(array) {
  return array.map(function (object) {
    return extractObject(object);
  });
}

function formToJSON(form) {
  return extractObject(form);
}
//# sourceMappingURL=formToJSON.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cerebral/forms/lib/helpers/formToJSON.js
// module id = 305
// module chunks = 5